import Handler from "@/core/domain/usecase/handler";

const changeServiceOrderRepository = (axios) => async (id, data) => {
    try {
        const response = await axios.put(`/service-order/${id}`, data)
        return response.data
    } catch (error) {
        if(error.isAxiosError) {
            throw new Handler().trataErro(error)
        } else {
            throw error
        }
    }
}

export default changeServiceOrderRepository